module.exports = __webpack_public_path__ + "prod/1.42.2/img/success-cases-three-bg.df3b7bb0.png";